// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iLLx","inner":"styles_inner__2VW9p","right":"styles_right__1DvO1","close":"styles_close__39Uea","footer":"styles_footer__-_1U1"};